import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnderline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M6 4v6a6 6 0 0 0 12 0V4" }), /* @__PURE__ */ _jsx("line", {
		x1: 4,
		x2: 20,
		y1: 20,
		y2: 20
	})]
});
export default SvgUnderline;
